import React, { Component } from "react";
import Previews from "./addImage";
import Slider from "react-slick";
import Editors from "./Editors";
export default class SliderWithImages extends Component {
  state = {
    textOne: "<h4>Slide One </h4><p>This is slide one Description",
    textTwo: "<h4>Slide Two </h4><p>This is slide one Description",
    textThree: "<h4>Slide Three </h4><p>This is slide one Description",
  };
  render() {
    var settings = {
      dots: true,
      arrows: true,
      infinite: true,
      speed: 1000,
      slidesToShow: 1,
      slidesToScroll: 1,
    };
    return (
      <div className="container fade-in">
        <Slider {...settings}>
          {this.props.element.data.map()}
          <div>
            <div className="row bg-white" style={{ height: "300px" }}>
              <div className="col-md-6">
                <Previews></Previews>
              </div>
              <div className="col-md-6 d-flex justify-content-center align-items-center">
                {this.props.editMode ? (
                  <Editors text={this.state.textOne}></Editors>
                ) : (
                  <div
                    dangerouslySetInnerHTML={{
                      __html: this.props.element.data.text,
                    }}
                  ></div>
                )}
              </div>
            </div>
          </div>
          <div>
            <div
              className="row bg-white"
              style={{ height: "300px", overflow: "hidden" }}
            >
              <div className="col-md-6">
                <Previews></Previews>
              </div>
              <div className="col-md-6 d-flex justify-content-center align-items-center">
                {this.props.editMode ? (
                  <Editors text={this.state.textTwo}></Editors>
                ) : (
                  <div
                    dangerouslySetInnerHTML={{
                      __html: this.props.element.data.text,
                    }}
                  ></div>
                )}
              </div>
            </div>
          </div>
          <div>
            <div className="row bg-white" style={{ height: "300px" }}>
              <div className="col-md-6">
                <Previews></Previews>
              </div>
              <div className="col-md-6 d-flex justify-content-center align-items-center">
                {this.props.editMode ? (
                  <Editors text={this.state.textThree}></Editors>
                ) : (
                  <div
                    dangerouslySetInnerHTML={{
                      __html: this.props.element.data.text,
                    }}
                  ></div>
                )}
              </div>
            </div>
          </div>
        </Slider>
      </div>
    );
  }

  //   render() {
  //     return (
  //       <section>
  //         <div class="container">
  //           <div class="row bg-light">
  //             <div class="col-md-6 p-0">
  //               <div class="bd-example">
  //                 <div
  //                   id="carouselExampleCaptions"
  //                   class="carousel slide"
  //                   data-ride="carousel"
  //                 >
  //                   <ol class="carousel-indicators">
  //                     <li
  //                       data-target="#carouselExampleCaptions"
  //                       data-slide-to="0"
  //                       class="active"
  //                     ></li>
  //                     <li
  //                       data-target="#carouselExampleCaptions"
  //                       data-slide-to="1"
  //                     ></li>
  //                     <li
  //                       data-target="#carouselExampleCaptions"
  //                       data-slide-to="2"
  //                     ></li>
  //                   </ol>
  //                   <div class="carousel-inner">
  //                     <div class="carousel-item active" style={{height:"100%"}}>
  //                       <Previews></Previews>
  //                     </div>
  //                     <div class="carousel-item" style={{height:"100%"}}>
  //                       <Previews></Previews>
  //                     </div>
  //                     <div class="carousel-item" style={{height:"100%"}}>
  //                       <Previews></Previews>
  //                     </div>
  //                   </div>
  //                   <a
  //                     class="carousel-control-prev"
  //                     href="#carouselExampleCaptions"
  //                     role="button"
  //                     data-slide="prev"
  //                   >
  //                     <span
  //                       class="carousel-control-prev-icon"
  //                       aria-hidden="true"
  //                     ></span>
  //                     <span class="sr-only">Previous</span>
  //                   </a>
  //                   <a
  //                     class="carousel-control-next"
  //                     href="#carouselExampleCaptions"
  //                     role="button"
  //                     data-slide="next"
  //                   >
  //                     <span
  //                       class="carousel-control-next-icon"
  //                       aria-hidden="true"
  //                     ></span>
  //                     <span class="sr-only">Next</span>
  //                   </a>
  //                 </div>
  //               </div>
  //             </div>
  //             <div
  //               class="col-md-6 bg-dark d-flex justify-content-center align-items-center flex-column p-5"
  //               style={{ height: "300px" }}
  //             >
  //               <div id="detail" class="detail-image-input-one">
  //                 <input
  //                   type="file"
  //                   class="edit-mode"
  //                   id="input-one"
  //                   name="image"
  //                   accept="image/*"
  //                   capture
  //                   style={{ display: "none" }}
  //                 />
  //                 <div class="carousel-caption d-md-block">
  //                   <h5 id="heading-input-one">The Slide One</h5>
  //                   <p id="disc-input-one">Add Discription</p>
  //                 </div>
  //               </div>
  //               <div id="detail" class="detail-image-input-two">
  //                 <input
  //                   type="file"
  //                   class="edit-mode"
  //                   id="input-two"
  //                   name="image"
  //                   accept="image/*"
  //                   capture
  //                   style={{ display: "none" }}
  //                 />
  //                 <div class="carousel-caption d-md-block">
  //                   <h5 id="heading-input-two">Title for slide two</h5>
  //                   <p id="disc-input-two">Discription two</p>
  //                 </div>
  //               </div>

  //               <div id="detail" class="detail-image-input-three">
  //                 <input
  //                   type="file"
  //                   class="edit-mode"
  //                   id="input-three"
  //                   name="image"
  //                   accept="image/*"
  //                   capture
  //                   style={{ display: "none" }}
  //                 />
  //                 <div class="carousel-caption d-md-block">
  //                   <h5 id="heading-input-three">Add title</h5>
  //                   <p id="disc-input-three">Add Discription</p>
  //                 </div>
  //               </div>
  //             </div>
  //           </div>
  //         </div>
  //       </section>
  //     );
  //   }
}
